import React from "react"
import { Tooltip } from "@mui/material";
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';

import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './Footer.css'


function Footer() {
    
    return(
        <>
            <div className="footerj footerj-inner  mt-5">
                <div className="container">
                    <div className=" d-flex">
                        <div className="col-6">
                            <h5>Get connected us with socail networks!</h5>
                        </div>
                      
                        <div className=" d-flex align-items-center justify-content-end socail-icon col-6">
                            <span><Tooltip title="Facebook"><FacebookOutlinedIcon href="https://www.facebook.com/shwapnonirman" className="padding" /></Tooltip></span>
                            <span><Tooltip title="WhatsApp"><WhatsAppIcon href='https://wa.me/message/3MLKG5PI34APN1' className="padding" /></Tooltip></span>
                            <span href=''><Tooltip title="Instagram"><InstagramIcon href="https://www.instagram.com/shwapnonirman/" className="padding" /></Tooltip></span>
                        </div> 
                    </div>  
                </div>
            </div> 

            <div className=" bg-dark text-center text-white">
                <div className="container">
                    <div className=" d-sm-flex flex-lg-row flex-md-row flex-sm-column">
                        <div className="col-lg-6">
                            <h4 className="mb-2 mt-lg-5 fw-bold">Company Name</h4>
                            <hr className="w-25 m-auto mb-3"/>
                            <span className="fw-bold fs-2 font-monospace">ShwapnoNirman.Com</span>
                        </div>
                        <div className=" col-lg-6 text-center">
                            <h4 className="mb-2 fw-bold mt-4 ">Contact</h4>
                            <hr className="w-25 m-auto mb-3"/>
                            <div className="d-grid contact">
                            <span className=" fw-bold p-2"><i class="fas fa-home me-3 text-white"></i>Bismillah Plaza, Ground Floor, Shop No: 22, <br className="m"/> Dighirjan Bazar, Nateshwar, Sonaimuri, Noakhali.</span>
                            
                            <span className=" fw-bold p-2">
                                <i className="fas fa-envelope me-3"></i>
                            shwapnonirman@gmail.com
                            </span>  
                            <span className=" fw-bold mb-5"><i class="fas fa-phone me-3"></i> +88 01986 76 97 65</span>
                            </div>
                        </div>

                    </div>
                    
                   
                </div>
            </div>
                
            <div className="text-center p-3 bg-success font-monospace fs-5">
                        <span className="text-light">© 2022 Copyright : </span> 
                        <small className="text-light"> Nasir Computer Center</small>
    </div>
    </>
    )
}

export default Footer;